import AnimatedEntrance from '@/views/common/AnimatedEntrance';
import {
  Box, CircularProgress, Stack, Typography,
} from '@datanomik/commons-ui';
import { useEffect, useState } from 'react';
import QRCode from 'react-qr-code';
import { useTranslation } from 'react-i18next';

type SupportPanelQRCode = {
  value: string;
}

export const SupportPanelQRCode = ({ value }: SupportPanelQRCode) => {
  const { t } = useTranslation();
  const [fakeLoading, setFakeLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFakeLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <AnimatedEntrance direction="down">
      <Stack
        justifyContent="center"
        alignItems="center"
        sx={{
          margin: '16px',
          padding: '16px',
          gap: '8px',
          backgroundColor: 'background.100',
          borderRadius: '8px',
        }}
      >
        <Typography fontWeight="500" fontSize="12px" color="neutral.main">
          {t('Scan the QR Code with your phone')}
        </Typography>
        <Box sx={{
          padding: '16px',
          backgroundColor: 'white',
          borderRadius: '8px',
        }}
        >
          {fakeLoading && (
            <Stack width={200} height={200} justifyContent="center" alignItems="center">
              <CircularProgress color="primary" size="20px" />
            </Stack>
          )}
          {!fakeLoading && (
            <AnimatedEntrance direction="down" distance={2}>
              <QRCode
                value={value}
                size={200}
              />
            </AnimatedEntrance>
          )}

        </Box>
      </Stack>
    </AnimatedEntrance>
  );
};
